
<template>
    <selection v-model="status" :options="options" :add-select="false" sort="none" :readonly="readonly" :required="required"/>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { GenericActiveStatus, GenericActiveStatusDescription } from "@/shared/enums/GenericActiveStatus";
import Selection, { SelectionEntry, EnumSelections } from "./Selection.vue";

export default defineComponent({
    name: "GenericStatus",
    components: {
        Selection
    },
    props: {
        modelValue: {
            type: Number,
            default: GenericActiveStatus.Active
        },
        readonly: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue"],
    data() {
        return {
            options: [] as SelectionEntry[]
        };
    },
    created() {
        this.options = EnumSelections(GenericActiveStatus, GenericActiveStatusDescription);
    },
    computed: {
        status: {
            get(): GenericActiveStatus {
                return this.modelValue;
            },
            set(value: GenericActiveStatus) {
                this.$emit("update:modelValue", value);
            }
        }
    }
});

</script>
